import CreateAdminModal from '../UI/modals/create_admin';
import UserActivityModal from '../UI/modals/user_activity';
import { IModalComponentProps } from '../context/modal_context';
import PreviewChatModal from '../UI/modals/preview_chat';
import RefundTransactionModal from '../UI/modals/refund_transaction';
import SaveAgreementModal from '../UI/modals/save_agreement';
import CardAgreementModal from '../UI/modals/card_agreement';
import ApproveActionModal from '../UI/modals/approve_action';

type ModalType = {
    modalId: string;
    confirmLabel?: string;
    cancelLabel?: string;
    isHeader?: boolean;
    isFooter?: boolean;
    variant: 'medium' | 'small' | 'custom' | 'large';
    Component: React.FC<IModalComponentProps> | null;
};

const modalIds = {
    CREATE_ADMIN_USER: 'CREATE_ADMIN_USER',
    PREVIEW_CHAT_ATTACHMENT: 'PREVIEW_CHAT_ATTACHMENT',
    REFUND_TRANSACTION: 'REFUND_TRANSACTION',
    SAVE_AGREEMENT: 'SAVE_AGREEMENT',
    VIEW_AGREEMENT: 'VIEW_AGREEMENT',
    USER_ACTIVITY_MODAL: 'USER_ACTIVITY_MODAL',
    APPROVE_ACTION: 'APPROVE_ACTION'
};

const createAdminModal: ModalType = {
    modalId: modalIds.CREATE_ADMIN_USER,
    confirmLabel: 'create',
    cancelLabel: 'cancel',
    isHeader: true,
    isFooter: true,
    variant: 'small',
    Component: CreateAdminModal
};

const userActivityModal: ModalType = {
    modalId: modalIds.USER_ACTIVITY_MODAL,
    variant: 'small',
    Component: UserActivityModal
};

const previewChatAttachment: ModalType = {
    modalId: modalIds.PREVIEW_CHAT_ATTACHMENT,
    variant: 'custom',
    Component: PreviewChatModal
};

const refundTransactionModal: ModalType = {
    modalId: modalIds.REFUND_TRANSACTION,
    variant: 'custom',
    Component: RefundTransactionModal,
    confirmLabel: 'yes_refund',
    isHeader: true,
    isFooter: true
};

const saveAgreementModal: ModalType = {
    modalId: modalIds.SAVE_AGREEMENT,
    variant: 'custom',
    Component: SaveAgreementModal,
    confirmLabel: 'save',
    cancelLabel: 'cancel',
    isHeader: true,
    isFooter: true
};

const viewAgreementModal: ModalType = {
    modalId: modalIds.VIEW_AGREEMENT,
    variant: 'custom',
    Component: CardAgreementModal,
    isHeader: true
};

const approveActionModal: ModalType = {
    modalId: modalIds.APPROVE_ACTION,
    variant: 'small',
    Component: ApproveActionModal,
    isHeader: true,
    isFooter: true,
    confirmLabel: 'confirm',
    cancelLabel: 'cancel'
};

const modals: ModalType[] = [
    createAdminModal,
    userActivityModal,
    previewChatAttachment,
    viewAgreementModal,
    saveAgreementModal,
    refundTransactionModal,
    approveActionModal
];

export { modals, modalIds };
